import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64c6dcae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fas fa-bell me-2" }),
    /*#__PURE__*/_createTextVNode("การแจ้งเตือน")
  ]),
  /*#__PURE__*/_createElementVNode("h6", { class: "card-subtitle text-muted" }, "แสดงข้อความแจ้งเตือนที่ได้รับจากระบบ")
], -1))
const _hoisted_3 = { class: "card-body my-3" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = {
  ref: "datatable",
  class: "table table-hover"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "#"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "การแจ้งเตือน"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "วันที่")
  ])
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tbody", null, null, -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, _hoisted_8, 512)
      ])
    ])
  ]))
}